import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function resetRequest(email) {
  try {
    const response = await fetch(base + 'reset-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ email: email }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur resetRequest', error);
    throw error;
  }
}

export async function resetPassword(mdp, token) {
  try {
    const authToken = token; 
    const response = await fetch(base + 'reset-password', {
      method: 'POST',
      credentials: "include", // Permet d'envoyer les cookies avec chaque requête, si http-only
      headers: { 'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}` // Ajout du token dans le header => penser à modifier .htaccess de l'API pour autoriser cet en-tête
       },
      body: new URLSearchParams({ mdp: mdp }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur resetPassword', error);
    throw error;
  }
}